import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

export default class extends Controller {
  static values = {
    defaultDate: String,
    maxDate: String,
    minDate: String,
  };

  connect() {
    this._fp = flatpickr(this.element, {
      dateFormat: "Y-m-d",
      defaultDate: this.defaultDateValue || null,
      maxDate: this.maxDateValue || null,
      minDate: this.minDateValue || null,
      allowInput: true,
      disableMobile: false,
    });
  }

  disconnect() {
    this._fp?.destroy();
  }
}
